<template>
  <v-dialog
    v-model="visible"
    v-if="form !== null"
    width="80vw"
    max-width="100vw"
    persistent
  >
    <v-card>
      <v-card-title>
        <p v-if="isNew" class="headline">新規レポート設定</p>
        <p v-else class="headline">レポート設定編集</p>
      </v-card-title>
      <v-card-text style="padding-top: 0px">
        <v-layout>
          <v-flex class="input-label" xs2>レポート名（必須）</v-flex>
          <v-flex xs10>
            <v-text-field
              v-model="form.name"
              hide-details
              style="padding-top: 0px;"
            />
          </v-flex>
        </v-layout>
        <v-layout>
          <v-flex class="input-label" xs2>説明</v-flex>
          <v-flex xs10>
            <v-text-field v-model="form.description" hide-details />
          </v-flex>
        </v-layout>
        <h3 v-if="isAdminUser" class="title">抽出条件</h3>
        <v-layout v-if="isAdminUser">
          <v-flex class="input-label" xs2>対象案件</v-flex>
          <v-flex xs10>
            <v-radio-group
              v-model="targetIOType"
              @change="onChangeStatus($event)"
              hide-details
              row
            >
              <v-radio
                v-for="(item, index) in targetIOItems"
                :key="index"
                :label="item.text"
                :value="item.value"
              />
            </v-radio-group>
          </v-flex>
        </v-layout>
        <v-layout v-if="showTargetInsertionOrder || !isAdminUser">
          <TargetInsertionOrder :form="form" />
        </v-layout>
        <v-layout>
          <v-flex class="input-label" xs2>レポート種別</v-flex>
          <v-flex xs10>
            <v-radio-group v-model="form.query.dimension" row hide-details>
              <v-radio
                v-for="(item, index) in dimensionItems"
                :key="index"
                :label="item.text"
                :value="item.value"
              />
            </v-radio-group>
          </v-flex>
        </v-layout>
        <v-layout>
          <v-flex class="input-label" xs2>クリエイティブ別</v-flex>
          <v-flex xs10>
            <v-switch
              v-model="form.query.isIncludeCreative"
              color="info"
              style="max-height: 260px"
            >
              <template v-slot:label>
                <span v-if="form.query.isIncludeCreative"
                  >クリエイティブ別</span
                >
                <span v-else>すべてのクリエイティブを合算</span>
              </template>
            </v-switch>
          </v-flex>
        </v-layout>
        <v-layout>
          <v-flex class="input-label" xs2>集計期間</v-flex>
          <v-flex xs10>
            <v-select
              v-model="periodText"
              :items="periodTextItems"
              class="select-box"
              style="max-height: 260px"
              menu-props="auto"
              hide-details
              dense
            />
            <span v-if="showPeriodSelectDate" class="red--text">
              ※ 開始日は必須です。
            </span>
          </v-flex>
        </v-layout>
        <v-layout>
          <v-flex xs2 />
          <v-flex xs10>
            <AppFormPeriodPicker
              v-if="showPeriodSelectDate"
              @inputStartDate="onInputStartDate"
              @inputEndDate="onInputEndDate"
              :start="form.query.startDate"
              :end="form.query.endDate"
              :disabled="false"
              :clearable="true"
              :disabledAlreadyStart="false"
              :isDateRestrictions="true"
              :isStartDateLimit="false"
              :fixDateWidth="true"
              class="date-select"
            />
          </v-flex>
        </v-layout>
        <v-layout>
          <v-flex class="input-label" xs2>集計間隔</v-flex>
          <v-flex xs10>
            <v-select
              v-model="intervalText"
              :items="intervalTextItems"
              class="select-box"
              menu-props="auto"
              hide-details
              single-line
              dense
            />
            <small
              v-if="form.query.isInsertionOrderBudgetInterval()"
              style="margin-left: 30px"
              class="red--text block"
            >
              予算期間ごとを選択した場合、レポート内に予算設定が表示されます。
            </small>
          </v-flex>
        </v-layout>
        <h3 class="title" style="">メール配信設定</h3>
        <v-layout>
          <v-flex class="input-label" xs2>定期メール配信</v-flex>
          <v-flex xs10>
            <AppStatus
              @click="updateStatus($event)"
              :value="form.status"
              color="info"
              with-icon
            />
          </v-flex>
        </v-layout>
        <IntervalReportMailSendSetting
          v-if="form.status === 'active'"
          :form="form"
          class="mail-send-setting"
        />
        <AdvancedSetting button-text="詳細設定" space="">
          <IntervalReportAdvancedSetting :form="form" />
        </AdvancedSetting>
      </v-card-text>
      <v-card-actions>
        <div style="display: flex; align-items: center; margin-left: 16px;">
          <v-icon @click="openHelpPage()" color="primary"
            >mdi-help-circle</v-icon
          >
          <span
            @click="openHelpPage()"
            style="font-size: 16px; margin-left: 8px; cursor: pointer; color: #007bff; text-decoration:underline;"
          >
            レポート出力 ヘルプはこちら
          </span>
        </div>
        <v-spacer />
        <AppButtonCancel @click="close" class="margin-right">
          キャンセル
        </AppButtonCancel>
        <ButtonDownload
          :intervalReport="form"
          :isIconButton="false"
          class="margin-right"
        />
        <v-btn @click="save" :disabled="!isValid" color="primary">
          条件を保存
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import TargetInsertionOrder from '@/components/Advertiser/Report/IntervalReport/IntervalReportModalAddTargetInsertionOrder'
import IntervalReportMailSendSetting from '@/components/Advertiser/Report/IntervalReport/IntervalReportModalAddMailSendSetting'
import IntervalReportAdvancedSetting from '@/components/Advertiser/Report/IntervalReport/IntervalReportModalAddAdvanceSetting'
import AdvancedSetting from '@/components/Shared/CrudUI/AdvancedSetting.vue'
import ButtonDownload from '@/components/Advertiser/Report/IntervalReport/IntervalReportListButtonCsvDownload'
import {
  Dimension,
  Interval,
  Period,
  TargetIOType,
  IntervalMailSendingStatus,
  IntervalReportRepository,
  IntervalReportFormFactory,
} from '@/models/Report/IntervalReport'
import { mapGetters } from 'vuex'

const targetIOItems = [
  {
    value: TargetIOType.ALL,
    text: 'すべての案件',
  },
  {
    value: TargetIOType.SELECT,
    text: '案件を選択する',
  },
]

const dimensionItems = [
  {
    value: Dimension.INSERTION_ORDER,
    text: '案件別レポート',
  },
  {
    value: Dimension.CAMPAIGN,
    text: 'キャンペーン別レポート',
  },
  {
    value: Dimension.DELIVERY_GROUP,
    text: '配信グループ別レポート',
  },
]

const intervalItems = [
  { value: Interval.DAILY, text: '日ごと' },
  { value: Interval.MONTHLY, text: '月ごと' },
  { value: Interval.INSERTION_ORDER_BUDGET, text: '予算期間ごと' },
  { value: Interval.TOTAL, text: '累計' },
]

const periodItems = [
  { value: Period.TOTAL, text: '全期間' },
  { value: Period.YESTERDAY, text: '前日分' },
  { value: Period.LAST_7_DAYS, text: '過去7日間分' },
  { value: Period.LAST_30_DAYS, text: '過去30日分' },
  { value: Period.CURRENT_MONTH, text: '当月分' },
  { value: Period.LAST_MONTH, text: '先月分' },
  { value: Period.SELECT, text: '日付指定' },
]

export default {
  name: 'IntervalReportRequestModalAdd',
  components: {
    TargetInsertionOrder,
    IntervalReportMailSendSetting,
    IntervalReportAdvancedSetting,
    AdvancedSetting,
    ButtonDownload,
  },
  props: {
    intervalReportId: {
      type: Number,
      default: undefined,
    },
    visible: {
      type: Boolean,
      default: false,
    },
    defaultInsertionOrderId: {
      type: Number,
      default: undefined,
    },
    source: {
      type: String,
      default: undefined,
    },
  },
  data() {
    return {
      showTargetInsertionOrder: false,
      form: null,
      emailAddresses: [],
      showPeriodSelectDate: false,
      isNew: !this.intervalReportId,
      modeText: this.isNew ? '登録' : '保存',
    }
  },
  computed: {
    ...mapGetters('currentAdvertiser', ['currentAdvertiser']),
    isAdminUser() {
      return this.currentAdvertiser.permission === 'admin'
    },
    targetIOItems() {
      return targetIOItems
    },
    dimensionItems() {
      return dimensionItems
    },
    targetIOType: {
      get() {
        return this.form.query.targetIOType
      },
      set(type) {
        this.form.query.targetIOType = type
        if (type === TargetIOType.SELECT) {
          this.showTargetInsertionOrder = true
        } else {
          this.showTargetInsertionOrder = false
          this.form.query.insertionOrderAddedList = []
        }
      },
    },
    intervalTextItems() {
      return intervalItems.map(item => item.text)
    },
    periodTextItems() {
      return periodItems.map(item => item.text)
    },
    intervalText: {
      get() {
        return this.getItemText(intervalItems, this.form.query.interval)
      },
      set(text) {
        this.form.query.interval = this.getItemValue(intervalItems, text)
      },
    },
    periodText: {
      get() {
        return this.getItemText(periodItems, this.form.query.period)
      },
      set(text) {
        const period = this.getItemValue(periodItems, text)
        if (period === Period.SELECT) {
          this.showPeriodSelectDate = true
          this.form.query.setDefaultDate()
        } else {
          this.showPeriodSelectDate = false
          this.form.query.resetDate()
        }
        this.form.query.period = period
      },
    },
    isValid() {
      return this.form.isValid()
    },
  },
  async created() {
    if (this.isNew) {
      const advertiserId = parseInt(this.$route.params.advertiserId)
      this.form = await IntervalReportFormFactory(
        advertiserId,
        this.isAdminUser,
      )
      if (this.defaultInsertionOrderId !== undefined) {
        this.form.status = 'active'
        this.form.query.targetIOType = TargetIOType.SELECT
        this.form.query.insertionOrderAddedList = this.form.insertionOrderList
          .filter(item => item.id === this.defaultInsertionOrderId)
          .map(item => ({ id: item.id, name: item.name }))
        this.form.name = `定期配信レポート 案件：${this.form.query.insertionOrderAddedList[0].name}`
      }
    } else {
      const intervalReport = await IntervalReportRepository.get(
        this.intervalReportId,
      )
      this.form = await IntervalReportFormFactory(
        null,
        this.isAdminUser,
        intervalReport,
      )
    }
    this.showTargetInsertionOrder =
      this.form.query.insertionOrderAddedList.length > 0
    this.showPeriodSelectDate = this.form.query.period === Period.SELECT
  },
  methods: {
    onChangeStatus(targetIOType) {
      this.targetIOType = targetIOType
      this.showTargetInsertionOrder = targetIOType === TargetIOType.SELECT
    },
    inputEmail(event) {
      this.form.notification.emails.splice(event.index, 1, event.text)
    },
    getItemValue(items, text) {
      return items.find(item => item.text === text).value
    },
    getItemText(items, value) {
      return items.find(item => item.value === value).text
    },
    async updateStatus(status) {
      const endDate = this.form.query.endDate
      if (!status && endDate) {
        await this.$confirm(undefined, {
          okText: 'はい',
          onlyOk: true,
          body: `集計期間の終了日が ${endDate} に設定されています。
              以降も継続してメールを送りたい場合は、集計期間の終了日を変更してください。`,
        })
      }
      this.form.status = status
        ? IntervalMailSendingStatus.INACTIVE
        : IntervalMailSendingStatus.ACTIVE
    },
    onInputStartDate(startDate) {
      this.form.query.startDate = startDate
    },
    onInputEndDate(endDate) {
      this.form.query.endDate = endDate
    },
    inputClosingDate(date) {
      this.form.notification.closingDate = date
    },
    async close() {
      const result = await this.$confirm('キャンセルしてもよろしいですか？')
      if (result) {
        this.$emit('cancel')
      }
    },
    async save() {
      try {
        this.isNew
          ? await IntervalReportRepository.create(this.form)
          : await IntervalReportRepository.update(this.form)
        if (this.isNew) {
          this.$sendEventToGA('buttonClick', {
            buttonName: 'intervalReportAddButton',
            source: this.source,
            status: this.form.status,
          })
        }
        this.$emit('clickSubmit')
      } catch (e) {
        console.error(e)
        throw new Error(`レポート出力条件の${this.modeText}に失敗しました`)
      }
    },
    openHelpPage() {
      window.open(
        'https://go.geologic.co.jp/adminmanual_report_download',
        '_blank',
        'noreferrer',
      )
    },
  },
}
</script>

<style scoped>
.v-input .v-text-field {
  padding: 0;
  margin: 14px 0;
}
.input-label {
  padding-top: 20px;
  color: #616161 !important;
  caret-color: #616161 !important;
}
.select-box {
  max-width: 140px;
  display: inline-block;
}
.title {
  margin-top: 40px;
  margin-bottom: 5px;
  padding-bottom: 10px;
  border-bottom: 1px solid gray;
}
.date-select {
  padding-top: 10px;
}
.mail-send-setting {
  margin-left: 30px;
}
.margin-right {
  margin-right: 10px;
}
</style>
